import { PUBLIC } from '@circlefin/permissions/sets'

import { LocalUnauthorizedReason } from '../../reasons'
import { PROTECTED_UNVERIFIED_EMAIL } from '../../sets'

import type { PermissionPluginFn } from '@circlefin/permissions'
import type { Session } from 'next-auth'

/**
 * Handle Email Verification Permissions.
 */
export function emailVerifyPlugin(
  status?: Session['status'],
): PermissionPluginFn {
  return {
    verify: ({ permissionsSet, authenticated }) => {
      // Skip when the user is not authenticated
      if (!authenticated) return

      // Check only when the user has unverified status
      if (status === 'unverified') {
        switch (permissionsSet) {
          case PUBLIC:
          case PROTECTED_UNVERIFIED_EMAIL:
            return {
              isAuthorized: true,
            }

          case undefined:
          default:
            // If a user has an unverified email, redirect to /verify-email page
            return {
              isAuthorized: false,
              failureReason: LocalUnauthorizedReason.UnverifiedEmail,
            }
        }
      } else {
        switch (permissionsSet) {
          case PROTECTED_UNVERIFIED_EMAIL:
            // User's with verified email cannot access /verify-email page
            return {
              isAuthorized: false,
              failureReason: LocalUnauthorizedReason.HasVerifiedEmail,
            }
          case undefined:
          default:
            return undefined
        }
      }
    },
  }
}
